import { render, staticRenderFns } from "./StdPatient.vue?vue&type=template&id=8ead0312&scoped=true&"
import script from "./StdPatient.vue?vue&type=script&lang=js&"
export * from "./StdPatient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ead0312",
  null
  
)

export default component.exports